import {useCallback, useEffect, useState} from 'react';

import {apiService} from '../apiService';

export const useDashboardReport = ({
  uid,
  startDate,
  endDate,
  enabled = true,
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [recordingsData, setRecordingsData] = useState([]);

  const fetchRecordings = useCallback(async () => {
    if (!uid || !enabled) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      let url = `/api/get-manager-dashboard-report?uid=${uid}`;

      if (startDate) {
        url += `&start_date=${startDate}`;
      }

      if (endDate) {
        url += `&end_date=${endDate}`;
      }

      const data = await apiService.get(url);

      if (data && data.body) {
        const recordings = Array.isArray(data.body) ? data.body : [];
        setRecordingsData(recordings);
      } else {
        setError('Received empty or invalid data from server');
      }
      setLoading(false);
    } catch (err) {
      console.error('Error fetching dashboard report:', err);
      setError('Failed to fetch data');
      setLoading(false);
    }
  }, [uid, startDate, endDate, enabled]);

  useEffect(() => {
    fetchRecordings();
  }, [fetchRecordings]);

  return {
    loading,
    error,
    recordingsData,
    refetch: fetchRecordings,
  };
};
